const TOKEN_KEYS = ["token", "adminToken", "authToken"];

export const getStoredToken = () => {
  for (const key of TOKEN_KEYS) {
    const token = localStorage.getItem(key);

    if (token) {
      return token;
    }
  }

  return null;
};

export const getTokenExpirationTime = (token) => {
  try {
    if (!token || typeof token !== "string") {
      return null;
    }

    const parts = token.split(".");

    if (parts.length !== 3) {
      return null;
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(
      Math.ceil(base64.length / 4) * 4,
      "="
    );

    const payload = JSON.parse(atob(padded));
    const expiresAt = Number(payload.exp) * 1000;

    return Number.isFinite(expiresAt) ? expiresAt : null;
  } catch (error) {
    return null;
  }
};

export const isTokenExpired = (token) => {
  const expiresAt = getTokenExpirationTime(token);

  return !expiresAt || expiresAt <= Date.now();
};

export const clearAuthSession = () => {
  TOKEN_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });

  localStorage.removeItem("user");
  localStorage.removeItem("role");
};

export const expireSession = () => {
  clearAuthSession();

  if (
    typeof window !== "undefined" &&
    window.location.pathname !== "/login"
  ) {
    window.location.replace("/login");
  }
};

export const attachAuthInterceptors = (api) => {
  api.interceptors.request.use(
    (config) => {
      const token = getStoredToken();

      if (token && isTokenExpired(token)) {
        expireSession();

        return Promise.reject(
          new Error("Session expired")
        );
      }

      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const requestUrl = String(error?.config?.url || "");

      const isLoginRequest =
        requestUrl.includes("/auth/login");

      if (status === 401 && !isLoginRequest) {
        expireSession();
      }

      return Promise.reject(error);
    }
  );

  return api;
};